import { useEffect, useRef } from 'react'
import { useAuthStore } from '../store/authStore'
import { useUiStore } from '../store/uiStore'

// Po této době neaktivity odhlásíme (jen když uživatel NEzaškrtl „zapamatovat").
const IDLE_MS = 30 * 60 * 1000 // 30 minut

/**
 * Sleduje aktivitu uživatele. Při dlouhé neaktivitě přihlášeného uživatele bez
 * „zapamatovat přihlášení" ho odhlásí a zobrazí přátelskou obrazovku.
 * Mountuje se globálně v App.
 */
export default function IdleTimer() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    // „Zapamatovat" → bez automatického odhlášení při neaktivitě.
    const remembered = localStorage.getItem('auth_remember') === '1'
    if (!isAuthenticated || remembered) return

    const logoutForIdle = () => {
      useAuthStore.getState().logout()
      useUiStore.getState().endSession('idle')
    }

    const reset = () => {
      if (timer.current) clearTimeout(timer.current)
      timer.current = setTimeout(logoutForIdle, IDLE_MS)
    }

    const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart', 'click', 'visibilitychange']
    const onActivity = () => {
      // Při návratu na záložku po dlouhé době taky vyhodnotíme čas.
      if (document.visibilityState === 'hidden') return
      reset()
    }
    events.forEach((ev) => window.addEventListener(ev, onActivity, { passive: true }))
    reset()

    return () => {
      if (timer.current) clearTimeout(timer.current)
      events.forEach((ev) => window.removeEventListener(ev, onActivity))
    }
  }, [isAuthenticated])

  return null
}
